import React from 'react';
import styled from 'styled-components';
import { Body5, Body7, Container } from '@ui';
import { Working } from '@ui/Working';

const MessageWrapper = styled.div`
  padding: 12px 16px;
  border-radius: 8px;
  background: ${({ $isUser, theme }) => ($isUser ? theme.themeColors.componentNoOpacity : 'transparent')};
  border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
`;

const RoleLabel = styled.div`
  margin-bottom: 6px;
`;

const SectionLabel = styled.div`
  margin-top: 8px;
  margin-bottom: 2px;
`;

const SectionContent = styled.div`
  white-space: pre-wrap;
  padding-top: 4px;
`;

export const RowChatPanelMessage = ({ message, isStreaming }) => {
  const { role, text, answer, reasoning, isOriginal } = message;
  const isUser = role === 'user';

  if (isUser) {
    return (
      <MessageWrapper $isUser>
        <RoleLabel>
          <Body5 bold>You</Body5>
        </RoleLabel>
        <Body5>{text}</Body5>
      </MessageWrapper>
    );
  }

  if (isOriginal) {
    return (
      <MessageWrapper $isUser={false}>
        <RoleLabel>{/* <Body5 bold>Original Result</Body5> */}</RoleLabel>
        {answer ? (
          <>
            <SectionLabel>
              <Body7 bold uppercase>
                Answer
              </Body7>
            </SectionLabel>
            <SectionContent>
              <Body5>{answer}</Body5>
            </SectionContent>
          </>
        ) : null}
        {reasoning ? (
          <Container top={4}>
            <SectionLabel>
              <Body7 bold uppercase>
                Reasoning
              </Body7>
            </SectionLabel>
            <SectionContent>
              <Body5>{reasoning}</Body5>
            </SectionContent>
          </Container>
        ) : null}
      </MessageWrapper>
    );
  }

  if (!answer && !reasoning && isStreaming) {
    return (
      <MessageWrapper $isUser={false}>
        <Working noVerticalPadding />
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper $isUser={false}>
      {answer ? (
        <>
          <SectionLabel>
            <Body5 bold isLowContrast>
              Answer
            </Body5>
          </SectionLabel>
          <SectionContent>
            <Body5>{answer}</Body5>
          </SectionContent>
        </>
      ) : null}
      {reasoning ? (
        <>
          <SectionLabel>
            <Body5 bold isLowContrast>
              Reasoning
            </Body5>
          </SectionLabel>
          <SectionContent>
            <Body5>{reasoning}</Body5>
          </SectionContent>
        </>
      ) : null}
    </MessageWrapper>
  );
};
